import { useSwrApi } from '@hooks/useSwrApi/useSwrApi';
import type { ApiSchema } from '@type/api/apiUtilityFn';

interface UseSwrScreeningItemByCandidateOptions {
  matchingCandidateId: string | number | null | undefined;
  enabled?: boolean;
}

/**
 * Hook to fetch a single screening item by matching candidate ID
 */
export const useSwrScreeningItemByCandidate = ({
  matchingCandidateId,
  enabled = true,
}: UseSwrScreeningItemByCandidateOptions) => {
  const shouldFetch = enabled && matchingCandidateId;

  const { data, error, isLoading, isValidating, mutate } = useSwrApi<ApiSchema<'ScreeningItemDto'>>({
    url: `/v1/screening/screenings/item/${matchingCandidateId}`,
    shouldFetch: !!shouldFetch,
    apiOptions: {
      revalidateOnFocus: false,
    },
  });

  return { data, error, isLoading, isValidating, mutate };
};
